export function makeTableSortable (table) {
    /*******************************
    *  table - HTML table element  *
    ********************************
    * sloupce podle kerych se muze tabulka sortovat musi mit v thead <th data-sort="number|date|string">...</th>
    * zejmena pro date a number je vhodne pouzit atribut data-sort-value: <td data-sort-value="2023-01-01">...</td>
    ********************************/
    if (!table) return;
    if (table.classList.contains("is-sortable")) return;

    table.classList.add("is-sortable");

    const tbody = table.tBodies[0];
    const collator = new Intl.Collator("cs", {
        numeric: true,
        sensitivity: "base",
    });

    table.querySelectorAll("th[data-sort]").forEach(header => {
        const sortable = document.createElement("span");
        sortable.classList.add("sort", "mr-1");
        header.prepend(sortable);
        sortable.innerHTML = `<i class="fa fa-fw fa-sort"></i>`;
        const asc = document.createElement("span");
        asc.classList.add("sort-asc", "mr-1");
        asc.style.display = "none";
        header.prepend(asc);
        asc.innerHTML = `<i class="fa fa-fw fa-arrow-down-a-z"></i>`;
        const desc = document.createElement("span");
        desc.style.display = "none";
        desc.classList.add("sort-desc", "mr-1");
        header.prepend(desc);
        desc.innerHTML = `<i class="fa fa-fw fa-arrow-up-z-a"></i>`;
    })

    table.querySelector("thead").addEventListener("click", event => {
        const th = event.target.closest("th[data-sort]");
        if (!th) return;

        const column = th.cellIndex;
        const type = th.dataset.sort;

        const ascending = th.dataset.order !== "asc";

        table.querySelectorAll("th[data-sort]").forEach(header => {
            delete header.dataset.order;
        });

        th.dataset.order = ascending ? "asc" : "desc";

        const rows = [...tbody.rows].map((row, originalIndex) => ({
            row,
            originalIndex,
        }));

        const getValue = row => {
            const cell = row.cells[column];

            return cell.dataset.sortValue
                ?? cell.textContent.trim();
        };

        rows.sort((a, b) => {
            let av = getValue(a.row);
            let bv = getValue(b.row);

            let result;

            switch (type) {
                case "number":
                    result = Number(av) - Number(bv);
                    break;

                case "date":
                    result = Date.parse(av) - Date.parse(bv);
                    break;

                default:
                    result = collator.compare(av, bv);
            }

            // stable sorting
            if (result === 0) {
                result = a.originalIndex - b.originalIndex;
            }

            return ascending ? result : -result;
        });

        rows.forEach(({row}) => tbody.appendChild(row));
    });
}